import { withInstall } from '../../utils'

import _Tabs from './src/tabs.vue'

export const SdTabs = withInstall(_Tabs)
export default SdTabs

export * from './src/tabs'
